const icons = {
  expert: '/static/expert.png',
  industry: '/static/serviceType.png'
}

const publicOptions = {
  isMore: false,
  hasMore: false,
  moreTitle: '展开'
}

const filterOptions = [
  {
    ...publicOptions,
    name: '专家类型',
    icon: icons.expert,
    prop: 'expertsType',
    tagList: [
      // { name: '全部', value: '', key: 'expertsTypeAll' },
      { name: '知识产权专家', value: '1', key: 'expertsType1' },
      { name: '专业技术专家', value: '2', key: 'expertsType2' },
      { name: '信息技术服务', value: '3', key: 'expertsType3' }
    ]
  },
  {
    ...publicOptions,
    name: '行业领域',
    icon: icons.industry,
    prop: 'industry',
    tagList: [
      // { name: '全部', value: '', key: 'industryAll' },
      { name: '集成电路', value: '1', key: 'industry1' },
      { name: '生物医药', value: '2', key: 'industry2' },
      { name: '人工智能', value: '3', key: 'industry3' },
      { name: '新能源汽车', value: '4', key: 'industry4' },
      { name: '高端装备制造', value: '5', key: 'industry5' },
      { name: '航空航天', value: '6', key: 'industry6' },
      { name: '新一代信息技术', value: '7', key: 'industry7' },
      { name: '新材料', value: '8', key: 'industry8' },
      { name: '新兴数字产业', value: '9', key: 'industry9' },
      { name: '现代农业', value: '10', key: 'industry10' },
      { name: '现代服务', value: '11', key: 'industry11' },
      { name: '专利信息情报、知识产权课题咨询研究', value: '12', key: 'industry12' },
      { name: '知识产权咨询研究', value: '13', key: 'industry13' },
      { name: '大数据应用', value: '14', key: 'industry14' },
      { name: '物联网、知识产权大数据', value: '15', key: 'industry15' },
      { name: '知识产权管理、保护和商用化', value: '16', key: 'industry16' },
    ]
  }
]

module.exports = {
  filterOptions
}
